import { OrganizationType } from '../interfaces/organizations';

export const MIN_APPROVED_COUNT = {
  [OrganizationType.BANK]: 300,
  [OrganizationType.MFO]: 10,
  [OrganizationType.INSURANCE]: 100,
  [OrganizationType.SCHOOL]: 100,
  [OrganizationType.BROKER]: 10,
  [OrganizationType.NPF]: 10,
  [OrganizationType.LEASING]: 10,
  [OrganizationType.MARKETPLACE]: 10,
  [OrganizationType.BANKRUPTCY]: 10,
  [OrganizationType.UNIVERSITY]: 10,
  [OrganizationType.BOOKMAKER]: 10,
  [OrganizationType.OFFLINE_SCHOOL]: 10,
};

export const SRAVNI_RATING_LENGTH = 3;
